import React, {useState} from 'react';
import ProgressBar from 'react-bootstrap/ProgressBar';
import CustomModal from "../../components/CustomModal/CustomModal";
import UserInfo from "../../components/UserInfo/UserInfo";
import { Dropdown, Button, Spinner, Card, Row, Col, Badge, Nav } from 'react-bootstrap';
import useMediaQuery from '../../hooks/useMediaQuery';
import { ROLES } from '../../model/roles';
import UtilityService from '../../services/UtillityServices/UtilityService';
import useClassi from '../../hooks/useClassi';
import useUtenti from "../../hooks/useUtenti";//NEW

const UsersToCourseManager = ({ users, openDeleteCourseModal, userLoggedIn, openUpdateStatoPagamentoModal, openGeneraAttestatoModal, isClassView = false, setShowFilterTable }) => {
  
  const isMax500px = useMediaQuery('(max-width: 500px)');
  const isMobile = useMediaQuery('(max-width: 768px)');
  const [percorsoFormativo, setPercorsoFormativo] = useState(null);
  const [currentView, setCurrentView] = useState('list'); // 'list' o 'percorso'
  const [currentTab, setCurrentTab] = useState('contenuti');
  const [selectedUserNome, setSelectedUserNome] = useState('');//NEW
  const [selectedUserCognome, setSelectedUserCognome] = useState('');//NEW
  const { getMaterialiClasseByUserId, loadingStateClassi } = useClassi();
  const [selectedUtente, setSelectedUtente] = useState(null);//NEW

  const {//NEW
      modalStateUtenti,
      setModalStateUtenti
    } = useUtenti();
  
  const groupUsersByRole = (users) => {
    return users?.reduce((groups, user) => {
      const role = user?.tipo_utente;
      if (!groups[role]) {
        groups[role] = [];
      }
      groups[role]?.push(user);
      return groups;
    }, {});
  };

  const groupedUsers = groupUsersByRole(users);

  const formatRoleName = (role) => {
    switch (role) {
      case "course_designer": return "Course designers";
      case "docente": return "Docenti";
      case "tutor": return "Tutor";
      case "corsista": return "Corsisti";
      default: return "Non specificato";
    }
  };

  const getEsitoEsameBadge = (esito) => {
    switch(esito) {
      case 'promosso':
        return { bg: 'success', text: 'light' };
      case 'bocciato':
        return { bg: 'danger', text: 'light' };
      case 'non_svolto':
      default:
        return { bg: 'warning', text: 'dark' };
    }
  };

  const rolePriority = {
    "course_designer": 1,
    "docente": 2,
    "tutor": 3,
    "corsista": 4,
    "default": 5
  };

  const sortedRoles = Object.keys(groupedUsers)?.sort((a, b) => {
    return (rolePriority[a] || rolePriority.default) - (rolePriority[b] || rolePriority.default);
  });

  const openInfoModal = (user) => {//NEW
    setSelectedUtente(user);
    setModalStateUtenti((state) => ({ ...state, showModalInfoUtente: true }));
  };

  const handleCloseModal = () => {
    setModalStateUtenti((state) => ({
      ...state,
      showModalInfoUtente: false,
    }));
  };

  const handleShowPercorsoFormativo = async (id_classe, id_utente, id_classe_utente, nome, cognome) => {
    setSelectedUserNome(nome);
    setSelectedUserCognome(cognome);
    setCurrentView('percorso');
    
    const obj = { 
      id_classe: id_classe, 
      id_utente: id_utente, 
      id_classe_utente: id_classe_utente 
    };
    const res = await getMaterialiClasseByUserId(obj);
    setPercorsoFormativo(res);
    renderPercorsoFormativo();
  };

  const renderActions = (utente) => {
    const actions = [];

    if (utente?.tipo_utente === "corsista") {
      actions.push({//NEW
        type: 'Azioni',
        icon: 'bi-info-circle text-dark',
        label: 'Dettagli utente',
        onClick: () => openInfoModal(utente),
        show: userLoggedIn?.role === ROLES.ADMIN || userLoggedIn?.role === ROLES.DEVELOPER || userLoggedIn?.role === ROLES.COURSE_DESIGNER || userLoggedIn?.role === ROLES.DOCENTE
      });

      actions.push({
        type: 'Azioni',
        icon: 'bi-file-earmark-text text-success',
        label: 'Genera attestato',
        onClick: () => openGeneraAttestatoModal(utente),
        show: userLoggedIn?.role === ROLES.ADMIN || userLoggedIn?.role === ROLES.DEVELOPER || userLoggedIn?.role === ROLES.COURSE_DESIGNER || userLoggedIn?.role === ROLES.DOCENTE
      });
      
      actions.push({
        type: 'Azioni',
        icon: 'bi-pencil text-warning',
        label: 'Modifica stato pagamento',
        onClick: () => openUpdateStatoPagamentoModal(utente),
        show: userLoggedIn?.role === ROLES.ADMIN || userLoggedIn?.role === ROLES.DEVELOPER 
      });
    }

    actions.push({
      type: 'Azioni',
      icon: 'bi-x-circle-fill text-danger',
      label: isClassView ? 'Rimuovi dalla classe' : 'Rimuovi dal corso',
      onClick: () => openDeleteCourseModal(utente),
      show: (userLoggedIn?.role === ROLES.ADMIN || userLoggedIn?.role === ROLES.DEVELOPER)
    });

    const visibleActions = actions.filter(action => action.show);

    if (visibleActions.length === 0) return null;

    return (
      <Dropdown drop="start">
        <Dropdown.Toggle variant="light" size="sm" className="no-arrow">
          <i className="bi bi-three-dots-vertical"></i>
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {visibleActions.map((action, index) => (
            <Dropdown.Item
              key={index}
              onClick={(e) => {
                e.stopPropagation();
                action.onClick();
              }}
            >
              <i className={`bi ${action.icon} me-2`}></i>
              {action.label}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    );
  };

  const renderPercorsoFormativo = () => {
    setShowFilterTable(false);//NEW
    const contenutiMap = new Map(percorsoFormativo?.contenuti.map(c => [c.id_contenuto, c]));

    const sortContenuti = (contenuti) => {
      // Funzione per trovare il livello di propedeuticità
      const findLevel = (contenuto) => {
        let level = 0;
        let current = contenuto;
        while (current.id_contenuto_propedeutico) {
          level++;
          current = contenutiMap.get(current.id_contenuto_propedeutico);
          if (!current) break;
        }
        return level;
      };

      return [...contenuti].sort((a, b) => {
        if (a.completato !== b.completato) return a.completato ? -1 : 1;
        
        if (a.completato) {
          return new Date(a.data_fine_prevista) - new Date(b.data_fine_prevista);
        } else {
          const levelA = findLevel(a);
          const levelB = findLevel(b);
          if (levelA !== levelB) return levelA - levelB;
          
          return a.id_contenuto - b.id_contenuto;
        }
      });
    };

    return (
      <div className="container-fluid px-4">
        {/* Header con pulsante indietro */}
        <div className="d-flex align-items-center mb-4">
          <Button 
            variant="link" 
            className="text-dark p-0 me-3"
            onClick={() => {
              setShowFilterTable(true);//NEW
              setCurrentView('list');
              setCurrentTab('contenuti');
            }}
          >
            <i className="bi bi-arrow-left fs-4"></i>
          </Button>
          <h4 className="mb-0">
            <i className="bi bi-journal-text text-primary me-2"></i>
            Percorso Formativo di <b>{selectedUserNome} {selectedUserCognome}</b>
          </h4>
        </div>

        {loadingStateClassi.isLoadingMaterialiClasseByUserId ? (
          <div className="text-center py-5">
            <Spinner animation="border" role="status" />
          </div>
        ) : percorsoFormativo && (
          <>
            {/* Info Corso Card */}
            <Card className="border-0 shadow-sm mb-4">
              <Card.Body className="p-4">
                <h4>{percorsoFormativo.denominazione_corso}</h4>
                <p className="text-muted mb-3">{percorsoFormativo.descrizione_corso}</p>
                <div className="d-flex flex-wrap gap-3">
                  {
                    percorsoFormativo.data_inizio && percorsoFormativo.data_fine && (
                      <div className="text-muted">
                        <i className="bi bi-calendar3 me-2"></i>
                        {new Date(percorsoFormativo.data_inizio).toLocaleDateString()} - {new Date(percorsoFormativo.data_fine).toLocaleDateString()}
                      </div>
                    )
                  }
                  {
                    !percorsoFormativo.denominazione?.includes('Classe Online - ') && (
                      <div className="text-muted">
                        <i className="bi bi-people me-2"></i>
                        Classe: {percorsoFormativo.denominazione}
                      </div>
                    )
                  }
                </div>
              </Card.Body>
            </Card>

            {/* Tabs Navigation */}
            <Nav variant="tabs" className="mb-4">
              <Nav.Item>
                <Nav.Link 
                  active={currentTab === 'contenuti'}
                  onClick={() => setCurrentTab('contenuti')}
                >
                  <i className="bi bi-collection-play me-2"></i>
                  Contenuti del corso
                </Nav.Link>
              </Nav.Item>
              {/* <Nav.Item>
                <Nav.Link 
                  active={currentTab === 'calendario'}
                  onClick={() => setCurrentTab('calendario')}
                >
                  <i className="bi bi-calendar-week me-2"></i>
                  Calendario Attività
                  {(percorsoFormativo.lezioni.length > 0 || percorsoFormativo.esami.length > 0) && (
                    <Badge bg="primary" className="ms-2">
                      {percorsoFormativo.lezioni.length + percorsoFormativo.esami.length}
                    </Badge>
                  )}
                </Nav.Link>
              </Nav.Item> */}
            </Nav>

            {/* Tab Content */}
            {currentTab === 'contenuti' ? (
              <Card className="border-0 shadow-sm">
                <Card.Body>
                  {percorsoFormativo.contenuti.length > 0 ? (
                    sortContenuti(percorsoFormativo.contenuti).map((contenuto) => (
                      <div 
                        key={contenuto.id_contenuto} 
                        className="d-flex align-items-center p-3 border-bottom"
                      >
                        <div className="me-3">
                          {contenuto.completato ? (
                            <i className="bi bi-check-circle-fill text-success fs-5"></i>
                          ) : contenuto.id_contenuto_propedeutico && 
                             !contenutiMap.get(contenuto.id_contenuto_propedeutico)?.completato ? (
                            <i className="bi bi-lock-fill text-muted fs-5"></i>
                          ) : (
                            <i className="bi bi-circle text-muted fs-5"></i>
                          )}
                        </div>
                        <div className="flex-grow-1">
                          <div className="fw-medium">{contenuto.titolo}</div>
                          <div className="d-flex align-items-center flex-wrap gap-3 mt-1">
                            <small className="text-muted">
                              <i className="bi bi-folder2 me-1"></i>
                              Area: {contenuto.titolo_area}
                            </small>
                            <small className="text-muted">
                              <i className="bi bi-clock me-1"></i>
                              {contenuto.peso_orario}m
                            </small>
                            {/* {contenuto.completato && contenuto.data_fine_prevista && (
                              <small className="text-success">
                                <i className="bi bi-check-circle me-1"></i>
                                Completato il {new Date(contenuto.data_fine_prevista).toLocaleDateString()}
                              </small>
                            )} */}
                            {contenuto.completato && contenuto.data_fine_prevista && (
                              contenuto.tipo_contenuto === 'test'
                              ?
                                contenuto.id_contenuti_test == null
                                ?
                                  <small className="text-dark">
                                    <i className="bi bi-info-circle me-1 text-primary"></i>
                                    Test non ancora superato
                                  </small>
                                :
                                  <small className="text-success">
                                    <i className="bi bi-check-circle me-1"></i>
                                    Test superato
                                  </small>
                              :
                                <small className="text-success">
                                  <i className="bi bi-check-circle me-1"></i>
                                  Completato il {new Date(contenuto.data_fine_prevista).toLocaleDateString()}
                                </small>
                            )}
                          </div>
                        </div>
                        <Badge bg={contenuto.opzionale ? "secondary" : "primary"} text={contenuto.opzionale ? "dark" : undefined}>
                          {contenuto.opzionale ? "Opzionale" : "Obbligatorio"}
                        </Badge>
                      </div>
                    ))
                  ) : (
                    <div className="text-center py-4">
                      <i className="bi bi-journal-x fs-1 text-muted mb-2"></i>
                      <p className="text-muted mb-0">Nessun contenuto disponibile</p>
                    </div>
                  )}
                </Card.Body>
              </Card>
            ) : (
              <Card className="border-0 shadow-sm">
                <Card.Body>
                  {percorsoFormativo.lezioni.length > 0 || percorsoFormativo.esami.length > 0 ? (
                    <>
                      {/* Lezioni ed Esami */}
                      <div className="row g-4">
                        {percorsoFormativo.lezioni.map((lezione) => (
                          <div key={lezione.id_lezione} className="col-12 col-lg-6">
                            <Card className="h-100 border-0 shadow-sm">
                              <Card.Body className="p-3">
                                <div className="d-flex justify-content-between align-items-start mb-3">
                                  <div>
                                    <h6 className="mb-1">
                                      <i className="bi bi-camera-video text-primary me-2"></i>
                                      {lezione.titolo}
                                    </h6>
                                    <div className="d-flex align-items-center gap-3">
                                      <small className="text-muted">
                                        <i className="bi bi-calendar3 me-1"></i>
                                        {new Date(lezione.data).toLocaleDateString()}
                                      </small>
                                      <small className="text-muted">
                                        <i className="bi bi-clock me-1"></i>
                                        {lezione.ora_inizio.slice(0, 5)} - {lezione.ora_fine.slice(0, 5)}
                                      </small>
                                    </div>
                                  </div>
                                  <Badge bg="info">Lezione</Badge>
                                </div>

                                {lezione.argomenti?.length > 0 && (
                                  <div className="d-flex gap-2 flex-wrap">
                                    {lezione.argomenti.map(arg => (
                                      <Badge 
                                        key={arg.id_argomento} 
                                        bg="light" 
                                        text="dark" 
                                        className="py-2 px-3"
                                        style={{ fontSize: '0.85em' }}
                                      >
                                        <i className="bi bi-bookmark me-1"></i>
                                        {arg.titolo}
                                      </Badge>
                                    ))}
                                  </div>
                                )}

                                {lezione.note && (
                                  <div className="mt-2 small text-muted">
                                    <i className="bi bi-info-circle me-1"></i>
                                    {lezione.note}
                                  </div>
                                )}
                              </Card.Body>
                            </Card>
                          </div>
                        ))}

                        {percorsoFormativo.esami.map((esame) => (
                          <div key={esame.id_calendario_esame} className="col-12 col-lg-6">
                            <Card className="h-100 border-0 shadow-sm">
                              <Card.Body className="p-3">
                                <div className="d-flex justify-content-between align-items-start mb-3">
                                  <div>
                                    <h6 className="mb-1">
                                      <i className="bi bi-pencil-square text-warning me-2"></i>
                                      Esame
                                    </h6>
                                    <div className="d-flex align-items-center gap-3">
                                      <small className="text-muted">
                                        <i className="bi bi-calendar3 me-1"></i>
                                        {new Date(esame.data).toLocaleDateString()}
                                      </small>
                                      <small className="text-muted">
                                        <i className="bi bi-clock me-1"></i>
                                        {esame.ora_inizio.slice(0, 5)} - {esame.ora_fine.slice(0, 5)}
                                      </small>
                                    </div>
                                  </div>
                                  <Badge bg="warning" text="dark">Esame</Badge>
                                </div>

                                {esame.utenti[0]?.prenotato === 1 && (
                                  <div className="d-flex align-items-center gap-2 mb-2">
                                    <Badge bg="light" text="dark" className="py-2">
                                      <i className="bi bi-calendar-check me-1"></i>
                                      Prenotato il {new Date(esame.utenti[0].data_prenotazione).toLocaleDateString()}
                                    </Badge>
                                  </div>
                                )}

                                {esame.utenti[0]?.esito_esame && (
                                  <div className="d-flex flex-wrap gap-2 align-items-center">
                                    <Badge 
                                      bg={getEsitoEsameBadge(esame.utenti[0].esito_esame).bg}
                                      text={getEsitoEsameBadge(esame.utenti[0].esito_esame).text}
                                      className="py-2"
                                    >
                                      <i className="bi bi-award me-1"></i>
                                      {esame.utenti[0].esito_esame === 'non_svolto' ? 'Non svolto' : 
                                       esame.utenti[0].esito_esame.charAt(0).toUpperCase() + 
                                       esame.utenti[0].esito_esame.slice(1)}
                                      {esame.utenti[0].voto && ` - Voto: ${esame.utenti[0].voto}`}
                                    </Badge>
                                  </div>
                                )}

                                {esame.utenti[0]?.note && (
                                  <div className="mt-2 small text-muted">
                                    <i className="bi bi-info-circle me-1"></i>
                                    {esame.utenti[0].note}
                                  </div>
                                )}

                   {/*              {esame.utenti[0]?.file_statino && (
                                  <div className="mt-3">
                                    <Button 
                                      variant="outline-primary"
                                      size="sm"
                                      href={esame.utenti[0].file_statino}
                                      target="_blank"
                                      className="d-inline-flex align-items-center"
                                    >
                                      <i className="bi bi-download me-2"></i>
                                      Scarica Statino
                                    </Button>
                                  </div>
                                )} */}
                              </Card.Body>
                            </Card>
                          </div>
                        ))}
                      </div>
                    </>
                  ) : (
                    <div className="text-center py-4">
                      <i className="bi bi-calendar-x fs-1 text-muted mb-2"></i>
                      <p className="text-muted mb-0">Nessuna attività programmata</p>
                    </div>
                  )}
                </Card.Body>
              </Card>
            )}
          </>
        )}
      </div>
    );
  };
  

  return (
    <div>
      {currentView === 'percorso' ? (
        renderPercorsoFormativo()
      ) : (
        sortedRoles?.map((role) => (
          <div key={role}>
            <h4 className='mt-3 mb-1'>{formatRoleName(role)}</h4>
            {groupedUsers[role]?.map((utente) => (
              <div key={utente?.id_utente} className='card p-3 my-2 rounded'>
                <div className={`${!isMax500px ? "d-flex justify-content-between" : ""} `}>
                  <div className={`${!isMax500px ? "d-flex gap-3" : ""} custom-card-title`}>
                    <div className={`custom-icon-container`}>
                      <i style={{ width: "45px", height: "45px" }} className={`bi custom-icon bi-person-fill bg-secondary text-dark fs-4`}></i>
                    </div>
                    <div className='align-self-center'>
                      <span className='d-block fs-5'>
                        <span className={`${isMax500px ? "d-block" : ""}`}>
                          {utente?.nome} {utente?.cognome}
                        </span>
                        <span className={`badge text-bg-primary ${!isMax500px ? "mx-1" : "me-1"}`}>{utente?.tipo_utente.replace("_", " ")}</span>
                        {utente?.tipo_utente === "corsista" && (userLoggedIn?.role === ROLES.ADMIN || userLoggedIn?.role === ROLES.DEVELOPER) && (
                          <span className={`badge ${UtilityService.getBadgeColorClass(utente.stato_pagamento)} ${!isMax500px ? "mx-1" : "me-1"}`}>
                            {UtilityService.getPaymentState(utente.stato_pagamento)}
                          </span>
                        )}
                        {utente.esito_esame && utente.esito_esame !== 'non_svolto' && (
                          <div className={`small text-muted ${isMobile ? 'w-100 text-center' : ''}`}>
                            <i style={{ color: 'green' }} className="bi bi-award me-1"></i>
                            Esito esame: <strong>{utente.esito_esame}</strong>
                          </div>
                        )}
                        {utente?.tipo_utente === "corsista" && utente.path_statino && (userLoggedIn?.role === ROLES.ADMIN || userLoggedIn?.role === ROLES.DEVELOPER) && (
                          <span> <a 
                            href={utente.path_statino} 
                            className={`btn btn-outline-info btn-sm ${isMobile && 'w-100 text-center'}`}
                            target="_blank" 
                            rel="noopener noreferrer"
                          >
                            <i className="bi bi-file-earmark-arrow-down me-1"></i>
                            Scarica Statino
                          </a></span>
                        )}
                        {utente?.tipo_utente === "corsista" && utente.path_attestato_verticale && (userLoggedIn?.role === ROLES.ADMIN || userLoggedIn?.role === ROLES.DEVELOPER) && (
                          <span> <a 
                            href={utente.path_attestato_verticale} 
                            className={`btn btn-outline-success btn-sm ${isMobile && 'w-100 text-center'}`}
                            target="_blank" 
                            rel="noopener noreferrer"
                          >
                            <i className="bi bi-file-earmark-text me-1"></i>
                            Scarica Attestato
                          </a></span>
                        )}
                      </span>
                      {utente?.id_utente && (
                        <span className='text-muted small d-block'>
                          <i className="bi bi-person-badge me-1"></i>
                          id: {utente.id_utente}
                        </span>
                      )}
                      {utente?.agenzia && (
                        <span className='text-muted small d-block'>
                          <i className="bi bi-building me-1"></i>
                          Agenzia: {utente.agenzia}
                        </span>
                      )}
                      <span className='text-muted small d-block'><i className="bi bi-envelope"></i> {utente?.username}</span>
                      {utente?.data_iscrizione && (
                        <span className='text-muted small d-block'>
                          <i className="bi bi-calendar-event me-1"></i>
                          {utente.tipo_utente === "corsista" ? "Iscritto" : "Assegnato"} il: {utente.data_accettazione_condizioni !== null ? UtilityService.formatDate(utente.data_accettazione_condizioni) : UtilityService.formatDate(utente.data_iscrizione)}
                        </span>
                      )}
                      {utente.tipo_utente === "corsista" && (
                        <div className="mt-2">
                          <small className="text-muted d-block mb-1">
                            Stato corso: {utente.ore_seguite_corso} su {utente.ore_totali_corso} ore  
                            {utente.ore_seguite_corso > 0 && (
                              <Button 
                                variant="primary"
                                size="sm"
                                onClick={() => handleShowPercorsoFormativo(utente.id_classe, utente.id_utente, utente.id_classe_utente, utente.nome, utente.cognome)}
                                style={{ height: '20px', left: '10px', position: 'relative' }}
                                className={`d-inline-flex align-items-center px-2 ${isMobile && 'w-100 justify-content-center'}`}
                              >
                                <small>Visualizza</small>
                              </Button>
                            )}
                          </small>
                          <ProgressBar
                            now={Math.min(100, Math.round((utente.ore_seguite_corso / utente.ore_totali_corso) * 100))}
                            label={`${Math.min(100, Math.round((utente.ore_seguite_corso / utente.ore_totali_corso) * 100))}%`}
                            striped
                            animated
                            variant={utente.ore_seguite_corso >= utente.ore_totali_corso ? 'success' : 'primary'}
                            style={{ height: '1rem' }}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                  <div className='align-self-center'>
                    {renderActions(utente)}
                  </div>
                </div>
              </div>
            ))}
          </div>
        ))
      )}
      <CustomModal
        show={modalStateUtenti.showModalInfoUtente}
        onHide={handleCloseModal}
        headerText="Informazioni utente"
        size={"lg"}
        body={<UserInfo userData={selectedUtente} />}
        closeButton={true}
        hideSaveBtn={true}
        onUndoChanges={handleCloseModal}
      />
    </div>
    
  );
};

export default UsersToCourseManager;
